/* eslint react-hooks/exhaustive-deps: "warn" */

import { DemoBlock } from 'ui/molecules/DemoBlock/DemoBlock';
import { EditorialStepsSection } from 'ui/molecules/EditorialStepsSection/EditorialStepsSection';
import { OurCustomersV2 } from 'ui/molecules/OurCustomers/OurCustomersV2';
import { NumberedFeatureCards } from 'ui/organisms/NumberedFeatureCards/NumberedFeatureCards';

import { AttributionStage } from 'features/crm/organisms/AttributionStage/AttributionStage';
import { CrmAppRows } from 'features/crm/organisms/CrmAppRows/CrmAppRows';
import { CrmHero } from 'features/crm/organisms/CrmHero/CrmHero';
import { DeliveryChannels } from 'features/crm/organisms/DeliveryChannels/DeliveryChannels';

import styles from './CRMPage.module.scss';

import {
  ATTRIBUTION,
  CRM_APPS,
  DATA_BLOCKS,
  DELIVERY_CHANNELS,
  DEMO_RECORD,
  RUN_STEPS,
  USE_CASES,
} from './CRMPage.data';

export const CRMPage = () => (
  <div className={styles.wrapper}>
    <CrmHero
      eyebrow="CRM Integrations"
      title="Automate your CRM enrichment with first-party government data"
      description="Native integrations for Salesforce, HubSpot, and Microsoft Dynamics. We map official registry records, financials, and ownership structures directly to your fields and sync them daily so your team always works with the freshest data."
      record={DEMO_RECORD}
    />

    <OurCustomersV2 hasBackground={false} />

    <CrmAppRows
      eyebrow="Three native apps"
      title="Built for the CRM your team already runs"
      description="Each app is developed and maintained by Global Database, and each one is built around how its users actually work — revenue operations in Salesforce, lean growth teams in HubSpot, sales and finance sharing one customer master in Dynamics."
      apps={CRM_APPS}
    />

    <EditorialStepsSection
      extra="The data"
      title="Five data blocks, written to your fields"
      description="This is what the integration delivers: identifiers, ownership, firmographics, financials and contacts — every value taken from an official source and mapped to the CRM fields you choose."
      steps={DATA_BLOCKS}
    />

    <AttributionStage
      eyebrow="Source attribution"
      title="Every value shows its source"
      description="Each field written to your CRM records where it came from — the registry, the exact filing, and the date it was pulled. Audit-ready by default: when someone asks where a number came from, the answer is already on the record."
      data={ATTRIBUTION}
    />

    <NumberedFeatureCards
      eyebrow="How teams run it"
      title="Enrich every record in your CRM. Continuously."
      description="Start with the records you already have, enrich new ones as they arrive, and let daily registry syncs keep everything current."
      items={RUN_STEPS}
      columns={3}
    />

    <DemoBlock
      title="Put the registry inside your CRM"
      description="See your own accounts enriched live — company numbers, financials and owners, written to your fields with the source attached."
      buttonTitle="Book a demo"
    />

    <EditorialStepsSection
      theme="dark"
      background="navy"
      extra="Use cases"
      title="What teams use it for"
      description="One integration, six jobs — across sales, operations, finance and compliance."
      steps={USE_CASES}
    />

    <DeliveryChannels label="Also delivered through" channels={DELIVERY_CHANNELS} />
  </div>
);
